export default __webpack_public_path__ + "static/media/NotoSansKR-Bold.a4ecc3f7.woff2";